import { SET_BANNERS, SET_HOME_CATEGORIES, SET_HOME_MERCHANTS, SET_HOME_POPULAR_CATEGORIES, SET_HOME_PREMIUM_PARTNERS } from "./home_types";

export const setBanners = (banners:any)=>({type: SET_BANNERS, banners})
export const setHomeCategories = (categories:any)=>({type: SET_HOME_CATEGORIES, categories})
export const setHomeMerchants = (merchants:any)=>({type: SET_HOME_MERCHANTS, merchants})
export const setPopularCategories = (popularCategories:any)=>({type: SET_HOME_POPULAR_CATEGORIES, popularCategories})
export const setPremiunPartners = (premiumParnters:any)=>({type: SET_HOME_PREMIUM_PARTNERS, premiumParnters})

